export enum ERROR {
    IS_REQUIRED = 'IS_REQUIRED',
}

export const MASK = new Array(100).fill(/[\wА-Яа-яЁё\s]/);
